import { FLOW_ROUTES } from '@withdrawals/constants'
import type { ExtendedSubFlow } from '@withdrawals/types'

export const findFlowByPathname = (url: string, defaultValue: ExtendedSubFlow = null): ExtendedSubFlow => {
  if (url) {
    const path = url.split('/').pop()
    const flowRoute = FLOW_ROUTES.find(route => route.pathname === path)
    return flowRoute?.subFlow ?? defaultValue
  }
  return defaultValue
}
